import {PersonDto} from "../../client/person/PersonApiClient";

export function formatPersonLastNameFirst(person: PersonDto): string {
    return (person.lastName ? person.lastName + (person.firstName ? " " : "") : "") + (person.firstName ?? "");
}

export function formatPersonFirstNameFirst(person: PersonDto): string {
    return (person.firstName ? person.firstName + (person.lastName ? " " : "") : "") + (person.lastName ?? "");
}
